<div class="tooltip">
  <div [ngClass]="[position, rentabilidadAnual ? 'cont-rentabilidad' : '']">
    <div *ngIf="rentabilidadAnual" style="text-align: right">
      <a (click)="hide()">
        <svg-icon
          src="../../../../assets/icons/close-tooltip.svg"
          [svgStyle]="{
            'padding-top.rem': 0.2,
            'height.rem': 1
          }"
        ></svg-icon>
      </a>
    </div>
    <p *ngIf="!rentabilidadAnual">{{ text }}</p>
    <i></i>
    <div *ngIf="rentabilidadAnual" class="container-menu">
      <h3>RENTABILIDAD</h3>
      <mat-divider></mat-divider>
      <div class="container-rentabilidad">
        <label class="label-dia">30 días</label>
        <label>{{ rentabilidadMensual?.rentabilidad | number }}%</label>
        <label class="label-dia">6 meses</label>
        <label>{{ rentabilidadSemestral?.rentabilidad | number }}%</label>
        <label class="label-dia">12 meses</label>
        <label>{{ rentabilidadAnual?.rentabilidad | number }}%</label>
      </div>
      <i></i>
    </div>
  </div>
</div>
